/**
 * Settings Page - API Key Management and Model Configuration
 * Validates: Requirements 12.1, 12.3, 12.5 - API key management
 * Validates: Requirements 21.1, 21.2, 21.3, 21.4 - Model configuration
 */
import { ApiKeyManager, ModelSettingsManager } from '../components/settings';

export function SettingsPage() {
  return (
    <div className="h-full overflow-auto">
      <div className="max-w-5xl mx-auto p-6 lg:p-8">
        <h1 className="text-2xl font-bold text-white mb-6">Settings</h1>
        
        {/* API Keys Section - Validates: Requirements 12.1, 12.3, 12.5 */}
        <ApiKeyManager />

        {/* Model Settings Section - Validates: Requirements 21.1, 21.2, 21.3, 21.4 */}
        <ModelSettingsManager />
      </div>
    </div>
  );
}
